"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Event = _interopRequireDefault(require("./events/Event.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/MapEvent
 */


/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
 */
var MapEvent =
/** @class */
function (_super) {
  __extends(MapEvent, _super);
  /**
   * @param {string} type Event type.
   * @param {import("./PluggableMap.js").default} map Map.
   * @param {?import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
   */


  function MapEvent(type, map, opt_frameState) {
    var _this = _super.call(this, type) || this;
    /**
     * The map where the event occurred.
     * @type {import("./PluggableMap.js").default}
     * @api
     */


    _this.map = map;
    /**
     * The frame state at the time of the event.
     * @type {?import("./PluggableMap.js").FrameState}
     * @api
     */

    _this.frameState = opt_frameState !== undefined ? opt_frameState : null;
    return _this;
  }

  return MapEvent;
}(_Event["default"]);

var _default = MapEvent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSEE7Ozs7O0FBS0E7Ozs7O0FBS0E7QUFBQTtBQUFBO0VBQXVCQTtFQUNyQjs7Ozs7OztFQUtBLGtCQUFZQyxJQUFaLEVBQWtCQyxHQUFsQixFQUF1QkMsY0FBdkIsRUFBcUM7SUFBckMsWUFDRUMsa0JBQU1ILElBQU4sS0FBVyxJQURiO0lBR0U7Ozs7Ozs7SUFLQUksS0FBSSxDQUFDSCxHQUFMLEdBQVdBLEdBQVg7SUFFQTs7Ozs7O0lBS0FHLEtBQUksQ0FBQ0MsVUFBTCxHQUFrQkgsY0FBYyxLQUFLSSxTQUFuQixHQUErQkosY0FBL0IsR0FBZ0QsSUFBbEU7O0VBQ0Q7O0VBQ0g7QUFBQyxDQXZCRCxDQUF1QkssaUJBQXZCOztlQXlCZUMsUSIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsInR5cGUiLCJtYXAiLCJvcHRfZnJhbWVTdGF0ZSIsIl9zdXBlciIsIl90aGlzIiwiZnJhbWVTdGF0ZSIsInVuZGVmaW5lZCIsIkV2ZW50IiwiTWFwRXZlbnQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL01hcEV2ZW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19